import React, { FC } from 'react';
import { Link as ChakraUiLink, LinkProps as ChakraLinkProps } from '@chakra-ui/react';
import { LinkVariant } from './types';
import { withTooltip, Tooltip } from '../../hoc';
import type { TextStyles } from '@everfi/design-system/dist/tsc/types';

export interface LinkProps extends Omit<ChakraLinkProps, 'onClick'> {
  variant?: LinkVariant | string;
  tooltip?: Tooltip;
  textStyle?: TextStyles;
  onClick?: (e: React.MouseEvent<HTMLAnchorElement>) => void;
}

export const Link: FC<LinkProps> = React.forwardRef<HTMLLinkElement, LinkProps>((props, ref) => {
  const { children, textStyle, ...rest } = props;
  /**
   * DOM
   * */
  return (
    <ChakraUiLink
      ref={ref}
      data-object-type="core-link"
      textStyle={textStyle}
      {...rest}
      // aria-label={iconPosition === 'icon-only' && iconName ? iconName : undefined} // TODO - need to change the way the icon is passed to use the core icon component, aria-label can not be set in both CORE and SDK
    >
      {children}
    </ChakraUiLink>
  );
});

Link.displayName = 'Link';

export default withTooltip('CoreLink')(Link);
